import(/* webpackMode: "eager" */ "/codebuild/output/src698657515/src/app/global-error.prod.tsx");
